module.exports = __webpack_public_path__ + "img/Ac.2937cd99.jpg";